
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-a23a4f64\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./404.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a23a4f64\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./404.vue"),
  /* scopeId */
  "data-v-a23a4f64",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/404.vue
// module id = 580
// module chunks = 1